export default "__VITE_ASSET__BrMAQmj9__"